import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { Dialog } from '@mui/material';
import BaseButton from '../../../../components/BaseButton';

export const SignerRemoveDecisionDialog = (props) => {

    const { open, setOpen, handleSubmit, envelopeData, selectedRemoveSigner } = props

    let envelopeWillBeCompleted = false    
    if(envelopeData && selectedRemoveSigner){
        const notSignedSigners = (envelopeData?.signers || [])
        .filter(signer => signer.signer_key !== selectedRemoveSigner && ['created', 'submitted', 'on_signature'].includes(signer.status))

        if(notSignedSigners.length === 0){
            envelopeWillBeCompleted = true
        }
    }

    if(envelopeWillBeCompleted)
        return (
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <div className="dialog__row-container" style={{ justifyContent: 'space-between' }}>
                    <div style={{ width: '31px' }}></div>
                    <h2 style={{fontSize: '2rem'}}>Atenção!</h2>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="dialog__column-container" style={{textAlign: "center"}}>
                    <h3 style={{ margin: '0 auto 10px auto', width: '400px', fontSize: '1.6rem'  }}>Tem certeza que deseja remover este assinante?</h3>
                    <p  style={{ margin: '0 auto 10px auto', width: '400px', fontSize: '1.2rem', color: 'red' }}>Todos outros assinantes já completaram o processo de assinatura, caso este assinante for removido, o envelope será finalizado.</p>
                    <BaseButton
                        label="REMOVER ASSINANTE"
                        className="btn__container--center btn btn--red btn--animated"
                        onClick={() => handleSubmit()}
                    />
                </div>
            </Dialog>
        )

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <div className="dialog__row-container" style={{ justifyContent: 'space-between' }}>
                <div style={{ width: '31px' }}></div>
                <h2>Atenção!</h2>
                <IconButton
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <div className="dialog__column-container">
                <h3 style={{ marginBottom: '10px' }}>Tem certeza que deseja remover este assinante?</h3>
                <BaseButton
                    label="REMOVER ASSINANTE"
                    className="btn__container--center btn btn--red btn--animated"
                    onClick={() => handleSubmit()}
                />
            </div>
        </Dialog>
    );
}